import React, { useMemo } from "react"
import GraphHeaderTabs from '../GraphHeaderTabs'
import { graphOptions, normalizationGraphOptions, compatitionGraphLineColors, mainGraphLineColors, timeRangeGraphOptions } from '../../utils/constants'
import LineGraph from '../Graphs/LineGraph'
import { getInitialBrushRange, decorateLayers } from '../Graphs/graphUtils'
import { useGraphContext } from "../../context/graphContext"
import { Skeleton, Typography } from '@mui/material'
import Select from "../ui/SelectWithExternalLabel"

export default function CompetitiveGraph({ graphId, dataset}) {
    const { graphFig, handleGraphFunction } = useGraphContext()

    const { fig, displayMethod, timeRange, timeFrame, index } = graphFig

    const changeAlternativeDataPick = (data) => handleGraphFunction({...graphFig, ...data})
    const changeGraphFunctionPick = (data) => handleGraphFunction({...graphFig, displayMethod: data.value, timeRange: data.value === 'RC' ? timeRange : 'ALL'})
    const changeGraphNormalizationPick = (data) => handleGraphFunction({...graphFig, normalization: data.value})
    const layers = useMemo(() => 
        fig ? decorateLayers([...compatitionGraphLineColors.slice(0, fig.length -1), mainGraphLineColors[index]],fig, null, { display: 'line', color: true, name: false }) : null, 
    [fig, index])
    const initialRange = useMemo(() => layers && getInitialBrushRange(layers, timeFrame), [layers, timeFrame])
    const changeTimeRange = (data) => handleGraphFunction({...graphFig, timeRange: data.value})

    return (
        <div className="graph">
                <GraphHeaderTabs 
                    changePick={changeAlternativeDataPick} 
                    selected={graphFig} 
                    options={dataset} 
                />
                <div className="graph__header-right">
                    <div>
                        <div>
                            <Typography>Display method:</Typography>
                            <Select elevation={3} setValue={changeGraphFunctionPick} value={displayMethod} options={graphOptions}/>
                        </div>

                        {displayMethod === 'RC' &&
                            <div>
                                <Typography>Baseline:</Typography>
                                <Select elevation={3}  setValue={changeTimeRange} value={timeRange} options={timeRangeGraphOptions}/>
                            </div>
                        }
                        <div>
                            <Typography>Normalization:</Typography>
                            <Select elevation={3} setValue={changeGraphNormalizationPick} value={graphFig.normalization} options={normalizationGraphOptions}/>
                        </div>
                    </div>
                </div>
            { layers ? <LineGraph initialRange={initialRange} layers={layers} graphId={graphId} /> : <Skeleton width='100%' height='500px'/> }
        </div>
    )
}